import * as React from 'react';
import styled, { css } from 'styled-components';
import Modal from 'styled-react-modal';
import { moreThan } from '@adecco/base-app/src/constants/breakpoints/breakpoints';
import { panel } from '@adecco/base-app/src/styles/panels';
import Headline, { HeadlineStyled } from '@adecco/base-app/src/components/atoms/Headline/Headline';
import Paragraph from '@adecco/base-app/src/components/atoms/Paragraph/Paragraph';
import Button from '@adecco/base-app/src/components/atoms/Button/Button';

export interface ILegalNoticeModal {
  isOpen: boolean;
  closeModal: (accept: boolean) => void;
  headerTitle: string | null;
  content: string | null;
  mainButtonTitle: string;
}

const modalStyles = css`
  z-index: ${(props) => props.theme.zIndex.modal};
  margin-top: calc(${(props) => props.theme.headerSpacing.logoHeight} * 2.5);
  width: 85vw;
  height: auto;
  max-width: 800px;
  max-height: 75vh;
  background-color: ${(props) => props.theme.colors.white};
  ${panel};
  display: flex;
  flex-direction: column;
  padding: 0;

  ${moreThan('md')} {
    max-height: 70vh;
  }
`;

const StyledModal = Modal.styled`
 ${modalStyles};
`;

const ModalSection = styled.div`
  padding: 10px 20px;
`;

const ModalContent = styled(ModalSection)`
  overflow: auto;
  flex: 0 1 auto;
  margin: ${(props) => props.theme.margins.modalContent};
  padding: 0;

  p {
    &:nth-child(1) {
      margin-bottom: ${(props) => props.theme.margins.modalContentP1th};
    }

    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4),
    &:nth-child(5) {
      margin-bottom: ${(props) => props.theme.margins.modalContentP};
    }
  }

  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};
  }
`;

const ModalHeader = styled(ModalSection)`
  margin: ${(props) => props.theme.margins.modalHeader};
  padding: 0;
  ${HeadlineStyled} {
    margin: 0;
  }
`;

const ModalFooter = styled(ModalSection)`
  margin: ${(props) => props.theme.margins.modalFooter};
  padding: 0;
  flex: 0 0 auto;
  border-bottom: 0;
  display: flex;
  justify-content: space-between;
`;

const LegalNoticeModal: React.FunctionComponent<ILegalNoticeModal> = ({
  isOpen,
  closeModal,
  headerTitle,
  content,
  mainButtonTitle,
}) => {
  return (
    <StyledModal
      isOpen={isOpen}
      onBackgroundClick={() => closeModal(false)}
      onEscapeKeydown={() => closeModal(false)}
    >
      <ModalHeader>
        <Headline skin={2}>{headerTitle}</Headline>
      </ModalHeader>
      <ModalContent>{content && <Paragraph noTransform>{content}</Paragraph>}</ModalContent>
      <ModalFooter>
        <Button variant="small" onClick={() => closeModal(true)} datacy="age-confirm-modal-button">
          {mainButtonTitle}
        </Button>
      </ModalFooter>
    </StyledModal>
  );
};

export default LegalNoticeModal;
